/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAgentsQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListAgentsQueryParamOrder = ClosedEnum<
  typeof ListAgentsQueryParamOrder
>;

export type ListAgentsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  limit?: number | undefined;
  order?: ListAgentsQueryParamOrder | undefined;
};

/** @internal */
export const ListAgentsQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListAgentsQueryParamOrder
> = z.nativeEnum(ListAgentsQueryParamOrder);
/** @internal */
export const ListAgentsQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListAgentsQueryParamOrder
> = ListAgentsQueryParamOrder$inboundSchema;

/** @internal */
export const ListAgentsRequest$inboundSchema: z.ZodType<
  ListAgentsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  limit: z.number().int().default(20),
  order: ListAgentsQueryParamOrder$inboundSchema.default("desc"),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListAgentsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  limit: number;
  order: string;
};

/** @internal */
export const ListAgentsRequest$outboundSchema: z.ZodType<
  ListAgentsRequest$Outbound,
  z.ZodTypeDef,
  ListAgentsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListAgentsQueryParamOrder$outboundSchema.default("desc"),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listAgentsRequestToJSON(
  listAgentsRequest: ListAgentsRequest,
): string {
  return JSON.stringify(
    ListAgentsRequest$outboundSchema.parse(listAgentsRequest),
  );
}
export function listAgentsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentsRequest' from JSON`,
  );
}
